<template>
  <b-modal
      :visible="visible"
      id="admin-non-metrc-facet-value-modal"
      :title="isEdit ? 'Edit Facet Value' : 'Add Facet Value'"
      @hidden="$emit('cancel')"
      hide-footer
      centered
  >
    <b-form @submit.prevent="submitForm">
      <b-form-group label="Facet Dimension">
        <b-form-select
            v-model="formData.facet_key"
            :options="facetDimensions"
            :disabled="isEdit"
            :state="fieldValid('facet_key')"
        />
        <b-form-invalid-feedback :state="fieldValid('facet_key')">
          {{ formValidation.facet_key }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Value Key">
        <b-form-input
            v-model.trim="formData.value_key"
            type="text"
            :disabled="isEdit"
            :state="fieldValid('value_key')"
        />
        <b-form-invalid-feedback :state="fieldValid('value_key')">
          {{ formValidation.value_key }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Label">
        <b-form-input
            v-model.trim="formData.label"
            type="text"
            :state="fieldValid('label')"
        />
        <b-form-invalid-feedback :state="fieldValid('label')">
          {{ formValidation.label }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Sort Order">
        <b-form-input
            v-model="formData.sort_order"
            type="number"
            min="0"
            :state="fieldValid('sort_order')"
        />
        <b-form-invalid-feedback :state="fieldValid('sort_order')">
          {{ formValidation.sort_order }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-button type="submit" variant="success" :disabled="formState.processing">
        Submit
        <b-spinner v-if="formState.processing" class="ml-1" small/>
      </b-button>
      <b-btn type="button" variant="secondary" @click.prevent="close">Cancel</b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import {API_ROUTES} from "../api";

export default {
  name: "AdminNonMetrcFacetValueModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    facetValue: {
      type: Object,
      default: null
    },
    facetDimensions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formData: {
        facet_key: this.facetValue?.facet_key ?? this.facetDimensions[0]?.value ?? "",
        value_key: this.facetValue?.value_key ?? "",
        label: this.facetValue?.label ?? "",
        sort_order: this.facetValue?.sort_order ?? 0
      },
      formValidation: {},
      formState: {
        processing: false
      }
    }
  },
  computed: {
    isEdit() {
      return !!this.facetValue;
    }
  },
  methods: {
    close() {
      this.$root.$emit('bv::hide::modal', 'admin-non-metrc-facet-value-modal');
    },
    fieldValid(field) {
      return typeof this.formValidation[field] !== "undefined" && this.formValidation[field].length > 0 ? false : null;
    },
    applyValidationErrors(data) {
      let validationErrors = {};
      if (typeof data?.errors !== 'undefined') {
        for (let fieldName in data.errors) {
          validationErrors[fieldName] = data.errors[fieldName].join(', ');
        }
      }
      this.formValidation = validationErrors;
    },
    payload() {
      let payload = {
        label: this.formData.label,
        sort_order: this.formData.sort_order === "" ? null : Number(this.formData.sort_order)
      };

      if (!this.isEdit) {
        payload.facet_key = this.formData.facet_key;
        payload.value_key = this.formData.value_key;
      }

      return payload;
    },
    submitForm() {
      this.formState.processing = true;
      let url = this.isEdit
          ? `${API_ROUTES.ADMIN_NON_METRC_TAXONOMY_FACET_VALUES}/${this.facetValue.id}`
          : API_ROUTES.ADMIN_NON_METRC_TAXONOMY_FACET_VALUES;

      this.$api.post(url, this.payload()).then(({data}) => {
        this.formValidation = {};
        this.$emit('success', data.facet_value);
        this.close();
      }).catch(error => {
        let data = error.response?.data ?? {};
        this.$bvToast.toast(data.message ?? 'Failed to save facet value', {
          title: 'Error!',
          variant: 'danger'
        });
        this.applyValidationErrors(data);
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  }
}
</script>
